<template>
  <div class="progress-bar-container">
    <div :class="['bar', variant]" :style="`width: ${percentageLimited}%;`"></div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NProgressBar extends Vue {
  @Prop({ required: true, type: Number }) percentage!: number
  @Prop({
    type: String,
    validator: (prop: string) => ['neutral', 'accent', 'success'].includes(prop),
    default: 'neutral'
  })
  variant!: string

  private get percentageLimited() {
    return Math.min(this.percentage, 100)
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.progress-bar-container {
  height: $notch-space-2x;
  background-color: $notch-color-neutral-sand-200;
  border-radius: $notch-radius-full;

  .bar {
    border-radius: $notch-radius-full;
    height: 100%;

    &.neutral {
      background: $notch-color-neutral-grey-900;
    }

    &.accent {
      background: $notch-color-semantic-accent-500;
    }

    &.success {
      background: $notch-color-semantic-success-500;
    }
  }
}
</style>
